import { BaseModel } from "sjs-base-model";

// Returned Api Data sample
// const example = {
//     id: 123,
//     totalAmount: 1000000,
//     usedAmount: 2000,
//     remainingAmount: 998000,
//     dateFrom: 20220101,
//     dateTo: 20221231,
//     comment: "Eurex quota 2022",
//     created: "2021-12-31T17:32:28Z",
// }

export default class QuotaModel extends BaseModel {
    id = 0;
    totalAmount = 0;
    usedAmount = 0;
    remainingAmount = 0;
    dateFrom = 0;
    dateTo = 0;
    comment = "";
    created = "";

    constructor(data) {
        super();
        this.update(data);
    }
}
